import {
  MOUNT,
  UNMOUNT,
  FETCH_REPORT,
  FETCH_REPORT_START,
  FETCH_REPORT_SUCCESS,
  FETCH_REPORT_ERROR,
  UPDATE_REPORT,
  REMOVE_REPORT,
  CLEAR_REPORTS,
  ON_SELECT_FILTER,
  ON_UNSELECT_FILTER,
  CLEAR_FILTER,
  UPDATE_QUERY,
  UPDATE_QUERY_CHANGES,
  UPDATE_QUERY_SOURCE,
  FETCH_QUERY_SOURCE,
  FETCH_QUERY_SOURCE_START,
  FETCH_QUERY_SOURCE_SUCCESS,
  FETCH_QUERY_SOURCE_ERROR,
  RESET_QUERY,
  ADD_SPECIFICATION_CHART,
  REMOVE_SPECIFICATION_CHART,
  TOGGLE_DASHBOARD_QUERY,
  UPDATE_BAR_RANGE,
  CLEAR_BAR_RANGE,
  CLEAR_CHART_STATE,
  ON_SELECT_MAX_THERMAL,
  ON_SELECT_AVG_THERMAL,
  ON_CLEAR_MAX_THERMAL,
  ON_CLEAR_AVG_THERMAL,
  ON_TOGGLE_MAX_THERMAL,
  ON_TOGGLE_AVG_THERMAL,
  UPDATE_SELECTED_POINT_THERMAL,
  ON_CHART_TABLE_LOADING_END,
  chartsEnum,
  queryEnum,
  histogramCharts,
  thermalCharts
} from './constants'
import {
  createNamedAction
} from 'helpers/ActionUtil'

// Mount/Unmount
const mount = () => ({ type: MOUNT })
const unmount = () => ({ type: UNMOUNT })

// Report actions
const fetchReport = (report, query) => ({ type: FETCH_REPORT, report, query })

const fetchQuerySource = () => ({ type: FETCH_QUERY_SOURCE })
const fetchQuerySourceStart = () => ({ type: FETCH_QUERY_SOURCE_START })
const fetchQuerySourceSuccess = () => ({ type: FETCH_QUERY_SOURCE_SUCCESS })
const fetchQuerySourceError = (error) => ({ type: FETCH_QUERY_SOURCE_ERROR, error })

const updateReport = (report) => ({ type: UPDATE_REPORT, report })
const removeReport = (report, attr) => ({ type: REMOVE_REPORT, report, attr })
const clearReports = () => ({ type: CLEAR_REPORTS }) 

// Filter actions
const onSelectFilter = (report) => ({ type: ON_SELECT_FILTER, report })
const onUnselectFilter = (report) => ({ type: ON_UNSELECT_FILTER, report })
const clearFilter = () => ({ type: CLEAR_FILTER })

const onSelectMaxThermalAction = () => ({ type: ON_SELECT_MAX_THERMAL })
const onSelectAvgThermalAction = () => ({ type: ON_SELECT_AVG_THERMAL })
const onClearMaxThermalAction = () => ({ type: ON_CLEAR_MAX_THERMAL })
const onClearAvgThermalAction = () => ({ type: ON_CLEAR_AVG_THERMAL })
const onToggleMaxThermalAction = () => ({ type: ON_TOGGLE_MAX_THERMAL })
const onToggleAvgThermalAction = () => ({ type: ON_TOGGLE_AVG_THERMAL })

const fetchReportStart = (() => {
  const actionCommand = () => {
    return {
      type: FETCH_REPORT_START,
    }
  }
  const actions = Object.keys(chartsEnum)
    .reduce((result, key) => {
      const name = chartsEnum[key].value
      return {
        ...result,
        [name]: createNamedAction(name, actionCommand)
      }
    }, {})
  const getAction = (type) => {
    return actions[type]
  }
  return (type) => {
    const action = getAction(type)
    return dispatch => dispatch(action())
  }
})()

const fetchReportSuccess = (() => {
  const actionCommand = () => {
    return {
      type: FETCH_REPORT_SUCCESS,
    }
  }
  const actions = Object.keys(chartsEnum)
    .reduce((result, key) => {
      const name = chartsEnum[key].value
      return {
        ...result,
        [name]: createNamedAction(name, actionCommand)
      }
    }, {})
  const getAction = (type) => {
    return actions[type]
  }
  return (type) => {
    const action = getAction(type)
    return dispatch => dispatch(action())
  }
})()

const fetchReportError = (() => {
  const actionCommand = () => {
    return {
      type: FETCH_REPORT_ERROR,
    }
  }
  const actions = Object.keys(chartsEnum)
    .reduce((result, key) => {
      const name = chartsEnum[key].value
      return {
        ...result,
        [name]: createNamedAction(name, actionCommand)
      }
    }, {})
  const getAction = (type) => {
    return actions[type]
  }
  return (type, err) => {
    const action = getAction(type)
    return dispatch => dispatch(action(err))
  }
})()


const onChartTableLoadingEnd = (() => {
  const tableLoadingEndAction = () => {
    return {
      type: ON_CHART_TABLE_LOADING_END,
    }
  }
  const actions = Object.keys(chartsEnum)
    .reduce((result, key) => {
      const name = chartsEnum[key].value
      return {
        ...result,
        [name]: createNamedAction(name, tableLoadingEndAction)
      }
    }, {})
  const getAction = (type) => {
    return actions[type]
  }
  return (type) => {
    const action = getAction(type)
    return dispatch => dispatch(action())
  }
})()

const onThermalChartTypeSelect = (() => {
  const actions = thermalCharts
    .reduce((result, chart) => {
      const name = chart.value
      return {
        ...result,
        [name]: {
          max: createNamedAction(name, onSelectMaxThermalAction),
          avg: createNamedAction(name, onSelectAvgThermalAction)
        }
      }
    }, {})
  const getAction = (chartType, category) => {
    return actions[chartType][category]
  }
  return (chartType, category) => {
    const action = getAction(chartType, category)
    return dispatch => dispatch(action())
  }
})()

const onThermalChartTypeClear = (() => {
  const actions = thermalCharts
    .reduce((result, chart) => {
      const name = chart.value
      return {
        ...result,
        [name]: {
          max: createNamedAction(name, onClearMaxThermalAction),
          avg: createNamedAction(name, onClearAvgThermalAction)
        }
      }
    }, {})
  const getAction = (chartType, category) => {
    return actions[chartType][category]
  }
  return (chartType, category) => {
    const action = getAction(chartType, category)
    return dispatch => dispatch(action())
  }
})()

const onThermalChartTypeToggle = (() => {
  const actions = thermalCharts
    .reduce((result, chart) => {
      const name = chart.value
      return {
        ...result,
        [name]: {
          max: createNamedAction(name, onToggleMaxThermalAction),
          avg: createNamedAction(name, onToggleAvgThermalAction)
        }
      }
    }, {})
  const getAction = (chartType, category) => {
    return actions[chartType][category]
  }
  return (chartType, category) => {
    const action = getAction(chartType, category)
    return dispatch => dispatch(action())
  }
})()

const clearChartState = (() => {
  const clearChartStateAction = () => {
    return {
      type: CLEAR_CHART_STATE,
    }
  }
  const actions = Object.keys(chartsEnum)
    .reduce((result, key) => {
      const name = chartsEnum[key].value
      return {
        ...result,
        [name]: createNamedAction(name, clearChartStateAction)
      }
    }, {})
  const getAction = (type) => {
    return actions[type]
  }
  return (type) => {
    const action = getAction(type)
    return dispatch => dispatch(action())
  }
})()


const updateChartBarRange = (() => {
  const updateBarRangeAction = (start, end) => {
    return {
      type: UPDATE_BAR_RANGE,
      start,
      end
    }
  }
  const actions = histogramCharts
    .reduce((result, chart) => {
      const name = chart.value
      return {
        ...result,
        [name]: createNamedAction(name, updateBarRangeAction)
      }
    }, {})
  const getAction = (type) => {
    return actions[type]
  }
  return (type, start, end) => {
    const action = getAction(type)
    return dispatch => dispatch(action(start, end))
  }
})()

const updateThermalSelectedPoint = (() => {
  const updateThermalSelectedPointAction = (projectId) => {
    return {
      type: UPDATE_SELECTED_POINT_THERMAL,
      projectId
    }
  }
  const actions = thermalCharts
    .reduce((result, chart) => {
      const name = chart.value
      return {
        ...result,
        [name]: createNamedAction(name, updateThermalSelectedPointAction)
      }
    }, {})
  const getAction = (type) => {
    return actions[type]
  }
  return (type, projectId) => {
    const action = getAction(type)
    return dispatch => dispatch(action(projectId))
  }
})()

const clearChartBarRange = (() => {
  const clearBarRangeAction = () => {
    return {
      type: CLEAR_BAR_RANGE,
    }
  }
  const actions = histogramCharts
    .reduce((result, chart) => {
      const name = chart.value
      return {
        ...result,
        [name]: createNamedAction(name, clearBarRangeAction)
      }
    }, {})
  const getAction = (type) => {
    return actions[type]
  }
  return (type) => {
    const action = getAction(type)
    return dispatch => dispatch(action())
  }
})()

// Query actions
const updateQuery = (() => {
  const updateQueryAction = (query) => {
    return {
      type: UPDATE_QUERY,
      query
    }
  }
  const actions = Object.keys(queryEnum)
    .reduce((result, key) => {
      const name = queryEnum[key].value
      return {
        ...result,
        [name]: createNamedAction(name, updateQueryAction)
      }
    }, {})
  const getAction = (type) => {
    return actions[type]
  }
  return (type, value) => {
    const action = getAction(type)
    return dispatch => dispatch(action(value))
  }
})()


const updateQueryChanges = (() => {
  const updateQueryChangesAction = (changes) => {
    return {
      type: UPDATE_QUERY_CHANGES,
      changes
    }
  }
  const actions = Object.keys(queryEnum)
    .reduce((result, key) => {
      const name = queryEnum[key].value
      return {
        ...result,
        [name]: createNamedAction(name, updateQueryChangesAction)
      }
    }, {})
  const getAction = (type) => {
    return actions[type]
  }
  return (type, value) => {
    const action = getAction(type)
    return dispatch => dispatch(action(value))
  }
})()

const updateQuerySource = (() => {
  const updateQuerySourceAction = (source) => ({
      type: UPDATE_QUERY_SOURCE,
      source
    })
  const actions = Object.keys(queryEnum)
    .reduce((result, key) => {
      const name = queryEnum[key].value
      return {
        ...result,
        [name]: createNamedAction(name, updateQuerySourceAction)
      }
    }, {})
  const getAction = (type) => {
    return actions[type]
  }
  return (type, value) => {
    const action = getAction(type)
    return dispatch => dispatch(action(value))
  }
})()

const resetQuery = () => ({ type: RESET_QUERY })

const applyQuery = (queries, reports) => {
  return dispatch => {
    const promises = queries.map(query => dispatch(updateQuery(query.type, query.input)))
    Promise.all(promises)
    .then(() => {
      reports.map(report => dispatch(fetchReport(report.type, queries)))
    })
  }
}

function resetQueryAction(reports) {
  return dispatch =>
    Promise.resolve(dispatch(resetQuery()))
    .then(() => {
      reports.map(report => dispatch(fetchReport(report.type, null)))
    })
}

const addSpecificationChart = () => ({ type: ADD_SPECIFICATION_CHART })

const removeSpecificationChart = (index) => ({ type: REMOVE_SPECIFICATION_CHART, index})

const toggleDashboardQuery = () => ({ type: TOGGLE_DASHBOARD_QUERY })

export {
  mount,
  unmount,
  fetchReport,
  fetchReportStart,
  fetchReportSuccess,
  fetchReportError,
  updateReport,
  removeReport,
  clearReports,
  onSelectFilter,
  onUnselectFilter,
  clearFilter,
  updateQuery,
  updateQueryChanges,
  updateQuerySource,
  resetQuery,
  applyQuery,
  resetQueryAction,
  fetchQuerySource,
  fetchQuerySourceStart,
  fetchQuerySourceSuccess,
  fetchQuerySourceError,
  addSpecificationChart,
  removeSpecificationChart,
  toggleDashboardQuery,
  updateChartBarRange,
  clearChartBarRange,
  clearChartState,
  onThermalChartTypeSelect,
  onThermalChartTypeClear,
  onThermalChartTypeToggle,
  updateThermalSelectedPoint,
  onChartTableLoadingEnd
}